const Roles = {
        Patient: 'Patient',
        Doctor:'Doctor'
   };

export default Roles;